import { AccountCardItem, AccountCardType } from '../../models/account';

export function favoriteAccountsSelector(accounts: AccountCardItem[] | undefined): AccountCardItem[] {
    if (!accounts || accounts.length === 0) {
        return [];
    }

    const favAccounts = accounts.filter((account) => account.favorite);
    const someNormalAccounts = favAccounts.some((account) => account.accountType === AccountCardType.ACCOUNT);
    return favAccounts.length > 0 && someNormalAccounts ? favAccounts : accounts;
}
